import React from 'react';

import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';

import {FieldShape} from 'commons/shapes';
import {CONSTANT_VALUES} from 'commons/constants';
import AddressInnerForm from './AddressInnerForm';
import {InferPropTypes} from 'commons/types/Types';
import {AddressServiceRequest} from 'commons/models';
import {formValidator, setDefaultValue} from 'commons/utils/Functions';

AddressForm.propTypes = {
    kycId: PropTypes.number.isRequired,
    viewId: PropTypes.number.isRequired,
    viewKey: PropTypes.string.isRequired,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    consigneeData: PropTypes.any,
};

const FormControl = withFormik<InferPropTypes<typeof AddressForm.propTypes>, AddressServiceRequest>(
    {
        mapPropsToErrors: () => {
            return {
                expedientId: '',
                workflowId: '',
                viewId: '',
                viewFatherId: '',
                kycId: '',
                addressId: '',
                streetDescription: '',
                addressDescription: '',
                outdoorNumber: '',
                interiorNumber: '',
                zipCode: '',
                colonyKey: '',
                colonyDescription: '',
                municipalityKey: '',
                municipalityDescription: '',
                stateKey: '',
                stateDescription: '',
                countryKey: '',
                hasNext: '',
            };
        },
        mapPropsToValues: (props) => {
            const {consigneeData, kycId} = props;
            if (consigneeData) {
                return {
                    expedientId: setDefaultValue(consigneeData.expedientId, 0),
                    workflowId: setDefaultValue(consigneeData.workflowId, 0),
                    viewId: setDefaultValue(consigneeData.viewId, 0),
                    viewFatherId: setDefaultValue(consigneeData.viewFatherId, 0),
                    kycId: setDefaultValue(kycId, 0),
                    addressId: setDefaultValue(consigneeData.addressId, 1),
                    streetDescription: setDefaultValue(consigneeData.streetDescription, ''),
                    addressDescription: setDefaultValue(consigneeData.addressDescription, ''),
                    outdoorNumber: setDefaultValue(consigneeData.outdoorNumber, ''),
                    interiorNumber: setDefaultValue(consigneeData.interiorNumber, ''),
                    zipCode: setDefaultValue(consigneeData.zipCode, ''),
                    colonyKey: setDefaultValue(consigneeData.colonyKey, ''),
                    colonyDescription: setDefaultValue(consigneeData.colonyDescription, ''),
                    municipalityKey: setDefaultValue(consigneeData.municipalityKey, ''),
                    municipalityDescription: setDefaultValue(
                        consigneeData.municipalityDescription,
                        ''
                    ),
                    stateKey: setDefaultValue(consigneeData.stateKey, ''),
                    stateDescription: setDefaultValue(consigneeData.stateDescription, ''),
                    countryKey: setDefaultValue(consigneeData.countryKey, ''),
                    hasNext: setDefaultValue(consigneeData.hasNext, false),
                };
            } else {
                return {
                    expedientId: 0,
                    workflowId: 0,
                    viewId: 0,
                    viewFatherId: 0,
                    kycId: kycId,
                    addressId: null,
                    streetDescription: '',
                    addressDescription: '',
                    outdoorNumber: '',
                    interiorNumber: '',
                    zipCode: '',
                    colonyKey: '',
                    colonyDescription: '',
                    municipalityKey: '',
                    municipalityDescription: '',
                    stateKey: '',
                    stateDescription: '',
                    countryKey: CONSTANT_VALUES.MexicoId,
                    hasNext: false,
                };
            }
        },
        validateOnBlur: true,
        validateOnChange: true,
        validate: (values: AddressServiceRequest, props) => {
            const errors: FormikErrors<AddressServiceRequest> = {};
            formValidator(props.fields, errors, values);
            return errors;
        },
        handleSubmit: (values, actions) => {
            actions.setSubmitting(false);
            actions.props.submitHandler({...values});
        },
    }
)(AddressInnerForm);

function AddressForm(props: InferPropTypes<typeof AddressForm.propTypes>) {
    const {submitHandler, fields, viewId, consigneeData, viewKey, kycId} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            kycId={kycId}
            viewId={viewId}
            fields={fields}
            viewKey={viewKey}
            submitHandler={submitHandler}
            consigneeData={consigneeData}
        />
    );
}

export default AddressForm;
